import React, { FC } from 'react';
import cx from 'classnames';
import styles from './Badge.css';

type Props = {
  className?: string;
};

const Badge: FC<Props> = ({ className }): JSX.Element => (
  <span
    className={cx(styles.component, className)}
    data-testid="header-unread-messages-badge"
  />
);

export default Badge;
